export default function MySQL_RTRIM() {
  return (
    <div>
      <h2>MySQL_RTRIM</h2>    </div>
  );
}